<template>
  <div class="main">
    <ball></ball>
    <div class="nav">
      <Nav title="报告详情" :fixed="true"></Nav>
      <div class="top"></div>
    </div>
    <div class="pdf" ref="content">
      <iframe
        v-if="showpdf"
        :src="href"
        frameborder="0"
        width="100%"
        height="90%"
      ></iframe>
    </div>
    <!-- <div class="btn">
      <van-button size="large" type="info" @click="downloadIamge()"
        >预览报告</van-button
      >
    </div> -->
  </div>
</template>

<script>
import Nav from "../../../components/nav.vue";
import pdf from "vue-pdf";
import CMapReaderFactory from "vue-pdf/src/CMapReaderFactory.js";
import html2canvas from "html2canvas";
export default {
  components: {
    pdf,
    Nav,
  },
  data() {
    return {
      reportBase64: "",
      src: "",
      numPages: 0,
      page: 1,
      currentPage: 0,
      reqData: {},
      name: "",
      itemName: "",
      imgUrl: "",
      href: "",
      showpdf: false,
    };
  },
  created() {
    this.reqData = this.$route.query;
    this.name = this.$route.query.name;
    this.itemName = this.$route.query.itemName;
  },
  mounted() {
    // console.log(this.reqData);
    this.getReport();
  },
  methods: {
    base64ToBlob(fileBase64,fileType){
	let raw = window.atob(fileBase64);
	let rawLength = raw.length;
	let uint8Array = new Uint8Array(rawLength);
	while (rawLength--){
		uint8Array[rawLength] = raw.charCodeAt(rawLength);
	}
	return new Blob([uint8Array],{type: fileType});
},
    previewPdf(fileBase64) {
      let fileBlob = this.base64ToBlob(fileBase64, "application/pdf");
      console.log(123)
      this.href = window.URL.createObjectURL(fileBlob);
      this.href = "./web/viewer.html?file=" + this.href;
    
      this.showpdf = true;
      // window.open(this.href );
      // window.location.href = this.href  //本页面内跳转链接实现预览
    },
    downloadIamge() {
      html2canvas(this.$refs.content).then((resolve) => {
        this.imgUrl = resolve.toDataURL("image/png"); //此时就得到了dom元素转成了base64的图片
        // console.log(this.imgUrl);
        WeixinJSBridge.invoke("imagePreview", {
          urls: [this.imgUrl],
          current: this.imgUrl,
        });
        // wx.previewImage(
        //     {

        //       current:  "http://account.kmmds.top/datainfo_pic/mode_pic/baogao.png", // 当前显示图片的http链接
        //      urls: ["http://account.kmmds.top/datainfo_pic/mode_pic/baogao.png"] // 需要预览的图片http链接列表
        //   });
      });
    },

    async getReport() {
      // console.log(this.method_depy_type)
      try {
        let reqData = this.reqData;
        this.$showLoad();
        let url = "/report/newquerylisreportbysample";
        // console.log(R_data)
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          reqData,
          (data) => {
            this.$hideLoad();
            
            let base64 = data.data.data.Data.Report.substr(
              1,
              data.data.data.Data.Report.length - 2
            );
           this.previewPdf(base64)
            // this.src.promise.then((pdf) => {
            //   this.numPages = hospitalChekedDetail.numPages;
            // });
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
    dataURLtoBlob(dataurl) {
      var bstr = atob(dataurl);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: "pdf" });
    },
    test() {
      let URL = this.dataURLtoBlob(this.reportBase64);
      let name = this.name + this.itemName + "报告单.pdf";
      var reader = new FileReader();
      reader.readAsDataURL(URL);
      reader.onload = function (e) {
        if (window.navigator.msSaveOrOpenBlob) {
          var bstr = atob(e.target.result.split(",")[1]);
          var n = bstr.length;
          var u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          var blob = new Blob([u8arr]);

          // console.log(name);
          window.navigator.msSaveOrOpenBlob(blob, name);
        } else {
          // 转换完成，创建一个a标签用于下载
          const a = document.createElement("a");
          a.download = name; // 这里写你的文件名
          a.href = e.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  width: 100%;
  .nav {
    height: 8vh;
  }
  .pdf {
    height: 80vh;
    width: 95%;
    margin: 0px auto;
    overflow: scroll;
  }
  .btn {
    height: 10vh;
    width: 95%;
    margin: 0px auto;
  }
}
</style>